import Api from "@/services/Api";

export default {
  getVorgaenge() {
    return Api().get("/vorgaenge");
  },

  createVorgang(data) {
    return Api().post("/vorgaenge", data);
  },

  updateVorgang(data) {
    return Api().put("/vorgaenge/" + data.id, data);
  },

  getAdressen() {
    return Api().get("/adressen");
  },

  getArbeitsarten() {
    return Api().get("/arbeitsarten");
  },

  getMaterialien() {
    return Api().get("/materialien");
  },

  createMaterial(data) {
    return Api().post("/materialien", data);
  },

  createAdresse(data) {
    return Api().post("/adressen", data);
  },

  getTechniker() {
    return Api().get("/techniker");
  }
};
